<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      title="导入数据模板"
      id-key="UserId"
    >

        <div class="m18x">
            <el-input v-model="moduleName" placeholder="请输入模板名" />
        </div>

        <div  class="m18x">
            <el-input :rows="20" v-model="jsonData" type="textarea" placeholder="数据模板" />
        </div>

      <template slot="footer">
        <el-button type="primary" @click="addModule" 
          >添加</el-button
        >
    
        <!-- <el-button type="primary" @click="lodopPrint">打印</el-button> -->
      </template>
    </common-dialog>

    
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

// import {getLodop} from '@/utils/LodopFuncs'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },


  data() {
    return {
        moduleName: "",
        jsonData: "",
    }
  },
  methods: {
    addModule(){
        if(this.moduleName === "" || this.jsonData === ''){
            this.$message({
                type: 'warning',
                message: "选项不能为空"
            })
            return
        }

        let o = {
            moduleName: this.moduleName,
            data: JSON.parse(this.jsonData)
        }

        this.$emit('add-module', o);
        this.moduleName = "";
        this.jsonData = "";
        this.close();
    }
  }

};
</script>

<style lang="scss" scoped>
    .m18x{
        margin: 18px 0;
    }
</style>


